import { useEffect, useState } from 'react'
import { Button, Table, Pagination, Typography, Tag, Image, Flex, Select } from 'antd';
import dayjs from 'dayjs';
import UserInfoView from '../../components/community/user_info_view';
import { useNavigate } from 'react-router-dom';
import { MainLayoutUrl } from '../../router/router_path';
import { fetchAIArticleCategorys, fetchAIArticles } from '../../api/ai';
import { useDebouncedCallback } from 'use-debounce';
import PostReview from '../../components/community/post_review';

const AIArticlesScreen = () => {
    const navigateTo = useNavigate();
    const [tabData, setTabData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [currArticle, setCurrArticle] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [categories, setCategories] = useState([]);

    const tabCols = [
        {
            title: 'Post ID',
            dataIndex: 'postId',
            key: 'postId',
            render: (text, _) => {
                return <Typography.Text copyable style={{ fontSize: 12, color: '#afafaf' }}>{text}</Typography.Text>
            },
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            width: 200,
            render: (_, record) => {
                const { post } = record
                return <b>{post.title}</b>;
            },
        },
        {
            title: 'Author',
            dataIndex: 'user',
            key: 'user',
            render: (_, record) => {
                const { post } = record
                let { user } = post;
                return (
                    <UserInfoView user={user} />
                );
            }
        },
        {
            title: 'Cover',
            dataIndex: 'cover',
            key: 'cover',
            render: (text, _) => {
                if (!text) return '';
                return <Image src={text} style={{ maxWidth: 120, maxHeight: 60 }} />
            }
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            render: (text, _) => {
                return <Tag>{text.name}</Tag>
            }
        },
        {
            title: 'CreatedAt',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text, _) => {
                return <label style={{ fontSize: 12, color: '#afafaf' }}>{dayjs(text).format('YYYY-MM-DD HH:mm')}</label>
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record, index) => {
                return (
                    <Button.Group size='small'>
                        <Button type='link' onClick={() => { reviewHandle(record) }}>Review</Button>
                        <Button type='link' onClick={() => { editHandle(record) }}>Edit</Button>
                    </Button.Group>
                )
            }
        }
    ];
    const [searchParams, setSearchParams] = useState({
        categoryId: null
    });

    useEffect(() => {
        fetchData(pageNum, pageSize, searchParams);

        fetchAIArticleCategorys({ 'page.disable': true }).then(res => {
            if (res.list) {
                setCategories(res.list.map(item => {
                    return {
                        key: item.id,
                        label: item.name,
                        value: item.id
                    }
                }))
            }
        })
    }, [])

    const fetchData = (pNum, pSize, search) => {
        setLoading(true);

        let params = {
            'page.num': pNum,
            'page.size': pSize,
            ...search
        }
        fetchAIArticles(params).then(res => {
            if (res.list) {
                setTabData(res.list);
            }
            if (res.page) {
                setTotal(res.page.total);
            }
        }).finally(() => setLoading(false))
    }

    const pageChange = (page, size) => {
        setPageNum(page);
        setPageSize(size);
        fetchData(page, size, searchParams);
    }

    const reviewHandle = (record) => {
        setCurrArticle(record);
        setPreviewOpen(true);
    }

    const editHandle = (record) => {
        let { post } = record;
        post = { ...post, cover: record.cover, aiId: record.id ,categoryId: post.category.id, userId: post.user.userId };
        navigateTo(MainLayoutUrl.community.adminpost.item.path.replace(':id', post.id), { state: { detail: JSON.stringify(post) } })
    }

    const onSearchChange = useDebouncedCallback(
        (tag, value) => {
            let newParams = { ...searchParams };
            newParams[tag] = value;
            setSearchParams(newParams);
            setPageNum(1);
            fetchData(1, pageSize, newParams);
        },
        300
    )

    return (
        <div className='main-wrapper'>
            <div className='top-part cnt-item'>
                <Flex justify='flex-end'>
                    <Select
                        style={{ width: 200 }}
                        options={categories}
                        placeholder='select category...'
                        onChange={value => onSearchChange('categoryId', value)}
                        allowClear
                    />
                </Flex>
            </div>
            <div className='cnt-item'>
                <Table loading={loading} rowKey={(record) => record.id} rowClassName={'table-row'} size='small' dataSource={tabData} columns={tabCols} pagination={false} />
            </div>
            <div className='footer-part cnt-item'>
                <Pagination
                    total={total}
                    showTotal={(total) => `total ${total}`}
                    current={pageNum}
                    pageSize={pageSize}
                    showSizeChanger={true}
                    pageSizeOptions={[10, 20, 30, 50]}
                    onChange={(page, size) => pageChange(page, size)}
                />
            </div>
            <PostReview open={previewOpen} post={currArticle?.post} onClose={() => setPreviewOpen(false)} />
        </div>
    )
}

export default AIArticlesScreen;